import { render, staticRenderFns } from "./BuyerWarrantsDash.vue?vue&type=template&id=4a45b124"
import script from "./BuyerWarrantsDash.vue?vue&type=script&lang=js"
export * from "./BuyerWarrantsDash.vue?vue&type=script&lang=js"
import style0 from "./BuyerWarrantsDash.vue?vue&type=style&index=0&id=4a45b124&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports